<template>
  <div>
    <section v-if="isLoading" class="wam-content full-width">
      <spinner class="l-flex-row--center l-align-center" width="200" height="200" />
    </section>

    <section v-else-if="!hasUserActiveBusinessApps" class="wam-content full-width">
      <template>
        <section class="l-flex-column is-empty.zero-state">
          <p class="zero-state-message">
            We could not find any business app on your account.
          </p>
        </section>
      </template>
    </section>

    <div v-else class="sub-nav-wrapper">
      <Tag type="info" size="small">
        {{ productLabel }}
      </Tag>
      <iframe class="business-apps-iframe" :src="iframeLink" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import Vue from 'vue'
import { getTokenUserEmail } from '@/utils/helpers'
import { isEmpty } from 'lodash'
import { Tag } from 'element-ui'

export default {
    name: 'BusinessApps',

    components: {
        Tag,
    },

    data() {
        return {
            selectedBusinessApp: {},
            isLoading: false
        }
    },
    mounted() {
        if (!this.hasUserActiveBusinessApps) {
            this.isLoading = true
            this.retrieveBusinessAppsProductAccount().then(() => {
                this.isLoading = false
            })
        }
        this.selectedBusinessApp = this.storeSelectedBusinessApps
    },
    watch: {
        cmpProductAccountList: {
            handler: function(newValue) {
                this.selectedBusinessApp = newValue[0]
            }
        },
        storeSelectedBusinessApps: {
            handler: function(newValue) {
                this.selectedBusinessApp = newValue
            }
        }
    },

    computed: {
        ...mapState('data/settings', {
            productAccountList: state => state.businessApps.productAccountList,
            storeSelectedBusinessApps: state => state.businessApps.selectedBusinessApp
        }),

        ...mapState('account', {
            accountId: state => state.accountId,
            userRole: state => state.userRole,

        }),

        iframeLink() {
            if (isEmpty(this.selectedBusinessApp)) return null
            const baseURL = this.selectedBusinessApp.iframe_url
            const reformatedUrl = baseURL
                .replace('~ACCOUNT_ID~', this.accountId)
                .replace('~TOKEN~', 'TOKEN')
                .replace('~USER_EMAIL~', getTokenUserEmail(Vue.prototype.$keycloak))
            return reformatedUrl
        },
        hasUserActiveBusinessApps() {
            return !isEmpty(this.cmpProductAccountList)
        },
        cmpProductAccountList() {
            return this.productAccountList.filter((product) => {
                if (product.privileges) {
                    if (this.userRole === 'webo_admin') {
                        return true
                    }

                    if (!['webo_admin', 'webo_employee'].includes(this.userRole)) {
                        return false
                    }

                    if (this.userRole === 'webo_employee' && product.privileges[0].method_right === 'weboadmin') {
                        return false
                    }

                    return true
                }
                return true
            })
        },

        productLabel() {
            return this.selectedBusinessApp?.label ? this.selectedBusinessApp.label : ''
        },
    },
    methods: {
        ...mapActions('data/settings', ['retrieveBusinessAppsProductAccount']),
        setBusinessApp(product) {
            this.selectedBusinessApp = product
        },
        isBusinessAppSelected(id) {
            return id === this.selectedBusinessApp.id
        }
    }
}
</script>

<style lang="scss" scoped>
.sub-nav-wrapper {
  position: relative;
  .el-tag {
    position: absolute;
    color: #000;
  }
}
</style>
